package org.solyton.solawi.bid.module.banking.action.sepa

import org.evoleq.math.contraMap
import org.evoleq.optics.lens.FirstBy
import org.evoleq.optics.lens.times
import org.evoleq.optics.storage.Action
import org.evoleq.optics.storage.suffixed
import org.evoleq.optics.transform.addList
import org.solyton.solawi.bid.module.banking.data.SepaCollectionId
import org.solyton.solawi.bid.module.banking.data.api.ApiSepaPayments
import org.solyton.solawi.bid.module.banking.data.api.CreateSepaPaymentSuccessors
import org.solyton.solawi.bid.module.banking.data.application.BankingApplication
import org.solyton.solawi.bid.module.banking.data.application.sepaModule
import org.solyton.solawi.bid.module.banking.data.sepa.collection.sepaPayments
import org.solyton.solawi.bid.module.banking.data.sepa.sepaCollections
import org.solyton.solawi.bid.module.banking.data.toDomainType

const val CREATE_SUCCESSORS_FOR_SEPA_PAYMENTS = "CREATE_SUCCESSORS_FOR_SEPA_PAYMENTS"

fun createSuccessorsForPayments(
    data: CreateSepaPaymentSuccessors,
    targetCollectionId: SepaCollectionId,
    nameSuffix: String = ""
): Action<BankingApplication, CreateSepaPaymentSuccessors, ApiSepaPayments> = Action(
    name = CREATE_SUCCESSORS_FOR_SEPA_PAYMENTS.suffixed(nameSuffix),
    reader = { _ -> data },
    endPoint = CreateSepaPaymentSuccessors::class,
    writer = (sepaModule * sepaCollections * FirstBy{
        it.sepaCollectionId == targetCollectionId
    } * sepaPayments).addList() contraMap { payments: ApiSepaPayments -> payments.all.map{it.toDomainType()}}
)
